import React, { Component } from 'react'

import Label from '../../../label'
import Icon from '../../../icon'
import { ElementIcons } from '../../../icons'

class SelectMultiOption extends Component {
  shouldComponentUpdate (nextProps) {
    if (nextProps.selected !== this.props.selected) return true
    if (nextProps.className !== this.props.className) return true
    if (nextProps.label !== this.props.label) return true
    if (nextProps.disabled !== this.props.disabled) return true

    return false
  }

  render () {
    return (
      <div className={'option-container multi-option element-dropdown__option ' + this.props.className}>
        <Label>{this.props.label}</Label>
        <input type='checkbox' onChange={() => {}} checked={this.props.selected} disabled={this.props.disabled} />
        <Icon icon={ElementIcons.Check_Selected} className='checked' icon2={ElementIcons.Check_Selected_Check} size={this.props.size} injectSvg />
        <Icon icon={ElementIcons.Check_Normal} className='normal' size={this.props.size} injectSvg />
        <Icon icon={ElementIcons.Check_Disabled} className='disabled' size={this.props.size} injectSvg />
        <Icon icon={ElementIcons.Check_SelectedDisabled} className='checked-disabled' size={this.props.size} injectSvg />
        <Icon icon={ElementIcons.Check_Hover} className='hover' size={this.props.size} injectSvg />
      </div>
    )
  }
}

export default SelectMultiOption



// WEBPACK FOOTER //
// ./src/app/shared/elements/dropDown/SelectBox/SelectMultiOption/index.js